'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { getTestId } from '@marketplace-web/vendor-abstractions/web-ui-util'

type Props = {
  price: string
  oldPrice?: string | null
  testId?: string
}

const ItemBoxPricing = ({ price, testId, oldPrice }: Props) => {
  return (
    <div className="new-item-box__title" data-testid={getTestId(testId, 'title-container')}>
      <div className="title-content">
        <Text
          text={price}
          type={Text.Type.Caption}
          theme="muted"
          testId={getTestId(testId, 'price-text')}
          as="p"
        />
        {oldPrice ? (
          <>
            <Spacer orientation={Spacer.Orientation.Vertical} size={Spacer.Size.Small} />
            <Text
              text={oldPrice}
              type={Text.Type.Caption}
              theme="muted"
              strikethrough
              truncate
              testId={getTestId(testId, 'old-price-text')}
              as="p"
            />
          </>
        ) : null}
      </div>
    </div>
  )
}

export default ItemBoxPricing
